import React from 'react';
import CuadroListaEditable from '../../edicion/CuadroListaEditable.js';
import * as Data from '../../edicion/data/DataTorneoParticipantes.js';
import * as DTOs from '../../edicion/DTOs/TorneoParticipantesDTOs.js';
import * as Funciones from '../../edicion/funciones/FuncionesTorneoParticipantes.js';

const ParticipantesTorneo = (props) => {
  const torneo = props.datosElegidos?.torneo;
  const idTorneo = torneo?.id;
  const contexto = { torneo };

  return (
    <CuadroListaEditable
      titulo="Participantes"
      idPadre={idTorneo}
      data={Data}
      dtos={DTOs}
      funciones={Funciones}
      contexto={contexto}
    />
  );
};

export default ParticipantesTorneo;
